import React, { PureComponent } from 'react';
import withData from 'fetch-hoc';

import StaticMap from './StaticMap';
import Labels from './Labels';

class GermanyMap extends PureComponent {
  render() {
    if (!this.props.data) {
      return <div />
    }

    const { data } = this.props;
    const topoKey = Object.keys(data.objects)[0];
    const geometries = data.objects[topoKey].geometries
      .map(feat => ({
        ...feat,
        properties: {
          ...feat.properties,
          dissolveId: feat.properties.Wahlgebiet_ID.substr(0, 2)
        }
      }));

    data.objects[topoKey].geometries = geometries;

    return (
      <div className="result-map result-map-de">
        <div className="result-headline">So hat Deutschland gewählt</div>
        <div className="result-subline">Die stärksten Parteien in den Kreisen und kreisfreien Städten</div>
        <StaticMap labels={Labels.germany} data={data} overlayDissolveKey="dissolveId" />
      </div>
    );
  }
}

export default withData('data/ew_de_hist.topo.json')(GermanyMap);
